import React from 'react';

const Badge = () => {
    return (
        <div className="height-5 width-100 orange darken-2 badge-container" >
            <div className="badge amber accent-2 height-5">
                  <div className="line-container">
                        <span className="left-box">P</span>
                        <div className="line">
                    </div>
                    <span className="right-box">C</span>
                </div>
            </div>
        </div>                       
    )
};

export default Badge;
